module.exports = __webpack_public_path__ + "media/assets/images/campaigns/instagram-ftc-454db6ac0bc5983b93c9e319e4d4a572.png";